import { RecordOf } from '@opengov/compose-app/immutable';
import { IReportTemplate } from '@opengov/reporting-types';

export const ReportTemplate = RecordOf<IReportTemplate>({
  createdAt: null,
  creator: null,
  description: null,
  id: null,
  prompts: null,
  report: null,
  savedViews: null,
  standardLensTypes: null,
  standardReportName: null,
  updatedAt: null
});
